import { combineReducers } from 'redux'
import {
  REQUEST_SUPPLIERS, REQUEST_SUPPLIERS_SUCCESS, REQUEST_SUPPLIERS_FAILURE
} from '../actions/suppliers'


const INITIAL_STATE = { suppliers: [], error:null, isFetching: false, lastUpdated: null, formdata: {}
    };

export  default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    
    case REQUEST_SUPPLIERS:
      return  Object.assign({}, state, {
        isFetching: true,
        suppliers: [],
        error: null
        }
      )
    case REQUEST_SUPPLIERS_SUCCESS:
      return  Object.assign({}, state, 
        {isFetching: false,
        suppliers: action.suppliers,
        lastUpdated: action.receivedAt,
        error: null
        }
      )
    case REQUEST_SUPPLIERS_FAILURE:
        Object.assign({}, state, {
          isFetching: false,
          suppliers: [],
          error: action.error
          }
        )
    default:
      return state
  }
}





// WEBPACK FOOTER //
// ./src/reducers/supplier_reducer.js